import { useSelector } from '../redux/store';

// True when the logged-in user can access more than one practice. Gates every
// "Transfer to another practice" entry point.
//
// Reads the accessible-practice list the practice switcher and the transfer
// destination picker use (practiceTreatmentList.practiceTreatment.results). The
// sidebar's own check reads `state.practiceTreatment.results`, which the
// practiceTreatment slice never populates at the top level, so it is not reused here.
export const selectHasMultiplePractices = (state) =>
    (state.practiceTreatmentList?.practiceTreatment?.results?.length || 0) > 1;

const useHasMultiplePractices = () => useSelector(selectHasMultiplePractices);

// A lead (lead-detail object or table row) is transferable unless it is archived / mid-archive.
export const isLeadTransferable = (lead) => Boolean(lead)
    && !(lead.is_archived || lead.is_archive_pending || lead.originalData?.is_archived);

// ...and it can be transferred when the user also has several practices.
export const useCanTransferLead = (lead) => {
    const hasMultiplePractices = useHasMultiplePractices();
    return hasMultiplePractices && isLeadTransferable(lead);
};

export default useHasMultiplePractices;
